import { render, staticRenderFns } from "./UrlBuilder.vue?vue&type=template&id=0b215a34&scoped=true&"
import script from "./UrlBuilder.vue?vue&type=script&lang=js&"
export * from "./UrlBuilder.vue?vue&type=script&lang=js&"
import style0 from "./UrlBuilder.vue?vue&type=style&index=0&id=0b215a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b215a34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b215a34')) {
      api.createRecord('0b215a34', component.options)
    } else {
      api.reload('0b215a34', component.options)
    }
    module.hot.accept("./UrlBuilder.vue?vue&type=template&id=0b215a34&scoped=true&", function () {
      api.rerender('0b215a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UrlBuilder.vue"
export default component.exports